import React, { useState } from 'react';
import { Card, Button, Form, Alert, Modal } from 'react-bootstrap';
import axios from 'axios';


const CreerTournois = (props) => {
  const [nom, setNom] = useState('');
  const [maxParticipants, setMaxParticipants] = useState('');
  const [commentaire, setCommentaire] = useState('')
  const [lieu, setLieu] = useState('')
  const [error, setError] = useState('');
  const [confirmation,setConfirmation] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [date, setDate] = useState('');
  const apiUrl = process.env.REACT_APP_API_URL;



  const handleSubmit= async (e) => {
    e.preventDefault();
    setIsLoading(true);
    setConfirmation(false);

    if (!nom || !maxParticipants || !commentaire || !lieu || !date){
        setError("Veuillez remplir tous les champs du formulaire.");
        setIsLoading(false);
        return;
    }
    
    try {
      await axios.post(`${apiUrl}/tournois/ajouter`, {
        nom : nom,
        lieu : lieu,
        maxParticipants : maxParticipants,
        commentaire : commentaire,
        date : date,
        idEquipe : props.userData.user.donnée.results[0].id_equipe
      }, {
        withCredentials: true
      });

      setError(null);
      setIsLoading(false);
      window.location.reload(); 

    } catch (error) {
      console.log(error)
      if (error.response) {
        setIsLoading(false)
        setError(error.response.data.message);
      } else {
        setIsLoading(false)
        setError(true);
      }
    }
  };

  
  if (isLoading) {
    return (
    <div className="centered-content">
      <img src="/img/logo.png" alt="Logo" className="centered-logo" />
      <br/>
      <span className="loader"></span>
    </div>
    
    );  
  }

  return (
    <>
     <Card.Title as="h3" className="mb-0"><strong>Créer un nouveau tournoi</strong></Card.Title>
    <hr/>
    <br/>
       {confirmation && (
        <>
            <Modal show={confirmation} onHide={() => setConfirmation(false)}>
                    <Modal.Header closeButton>
                    <Modal.Title>Confirmation</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        Voulez-vous vraiment creer un tournoi ?
                    </Modal.Body>
                    <Modal.Footer>
                    <Button variant="secondary"  onClick={() => setConfirmation(false)} >
                        Quitter
                    </Button>
                    <Button variant="primary" onClick={(e) => handleSubmit(e)}style={{backgroundColor:"#00E676", borderColor:'#00E676'}}  >
                        Confirmer
                    </Button>
                    </Modal.Footer>
            </Modal>
        </>
        )}
      <Card.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form >
            <Form.Label>Nom du tournoi</Form.Label>
            <Form.Control type="text" placeholder="Entrez le nom du tournoi" value={nom} onChange={(e) => setNom(e.target.value)} required/>            
            <br/>
            <Form.Label>Lieu du tournoi</Form.Label>
            <Form.Control type="text" placeholder="Entrez le lieu du tournoi" value={lieu} onChange={(e) => setLieu(e.target.value)} required />
            <br/>
            <Form.Label>Date du tournoi</Form.Label>
            <br/>
            <input name="date_debut" type="date" id="date_debut" required value={date} onChange={(e) => {setDate(e.target.value)}} style={{width: '100%', borderRadius : '5px', padding:'.375rem .75rem'}}/>
              <br/><br/>
            <Form.Label>Nombre maximum de participants (Remarque : retirer votre équipe de ce nombre)</Form.Label>
            <Form.Control type="number" placeholder="Entrez le nombre maximum de participants" value={maxParticipants} onChange={(e) => setMaxParticipants(e.target.value)} required/>
          <br/>
          <Form.Label>Commentaire</Form.Label>
          <Form.Control as="textarea" placeholder="Ajoutez un commentaire"  rows={3} value={commentaire} onChange={(e) => setCommentaire(e.target.value)} />
          <Button variant="primary" onClick={() => setConfirmation(true)} style={{ marginTop: '1rem',backgroundColor:"#00E676", borderColor:'#00E676' }}>
            Créer le tournoi
          </Button>
        </Form>
      </Card.Body>
      <br/>

    </>
  );
};

export default CreerTournois;
